export enum TicketTemplateRouteName {
    Index = 'ticket-templates.index',
    Create = 'ticket-templates.create',
    Edit = 'ticket-templates.edit',
}

export default {
    path: 'ticket-templates',
    component: () => import('./pages/index.vue'),
    meta: {
        label: 'Ticket Templates',
        icon: 'fal fa-file-invoice fa-fw',
        location: 'sidebar',
        permission: 'manage-tickets',
        auth: true,
        group: 'main',
    },
    children: [
        {
            path: '',
            name: TicketTemplateRouteName.Index,
            component: () => import('./pages/templates.vue'),
            meta: {
                label: 'Ticket Templates',
                auth: true,
                location: 'sidebar',
                permission: 'manage-tickets',
                group: 'main',
            },
        },
        {
            path: 'create',
            name: TicketTemplateRouteName.Create,
            component: () => import('./pages/create.vue'),
            meta: {
                auth: true,
                label: 'Create Ticket Template',
                permission: 'manage-tickets',
                group: 'main',
            },
        },
        {
            path: ':ticketTemplateUuid/edit',
            name: TicketTemplateRouteName.Edit,
            component: () => import('./pages/edit.vue'),
            meta: {
                auth: true,
                label: 'Edit Ticket Template',
                permission: 'manage-tickets',
                group: 'main',
            },
        },
    ],
}
